// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__mEr-2","inputWrap":"CustomTip_inputWrap__1ENFi"};